export default __webpack_public_path__ + "static/media/presigninlogo.7cffdd1b.svg";